import { observer } from 'mobx-react';
import React from 'react';
import 'reactflow/dist/style.css';
import LegalEntityFolder from './LegalEntityFolder';
import OutlookLocationContentsViewerState from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';

interface ILegalEntityDocumentsProps {
	state: OutlookLocationContentsViewerState;
}

class LegalEntityRootFolder extends React.Component<
	ILegalEntityDocumentsProps,
	{}
> {
	componentDidMount(): void {

		let iconName = this.props.state.entityType ? 'Database' : 'SharepointLogo';
		this.props.state.lineItem.setIconInfo({ icon: iconName } as any);
		this.props.state.ensureInitialLoaded();
	}

	render() {

		return (
			<>
				{LegalEntityFolder.getFolderComponents(1, this.props.state)}
			</>
		);
	}
}

export default observer(LegalEntityRootFolder);
